import React, {memo, useMemo} from 'react';
import {TinaCMS, TinaProvider} from 'tinacms';
import PropTypes from 'prop-types';

export const defaultSettings = {
  enabled: false,
  toolbar: false,
  sidebar: false
};

//todo delete
// cms.plugins.add(ConditionalGroupFieldPlugin);
// cms.plugins.add(ResponsiveFieldsGroupFieldPlugin);

const TinaConfig = ({children, initSettings}) => {
  const cms = useMemo(() => {
    const cms = new TinaCMS({
      ...defaultSettings,
      ...initSettings
    });
    return cms;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TinaProvider cms={cms}>
      {children}
    </TinaProvider>
  );

};
TinaConfig.propTypes = {
  children: PropTypes.any,
  initSettings: PropTypes.object,
};
export default memo(TinaConfig);


